/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectWeeklyAvailabilityResource = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    FullTime: 'FULL_TIME'
} as const;
export type ProjectWeeklyAvailabilityResource = typeof ProjectWeeklyAvailabilityResource[keyof typeof ProjectWeeklyAvailabilityResource];


export function instanceOfProjectWeeklyAvailabilityResource(value: any): boolean {
    for (const key in ProjectWeeklyAvailabilityResource) {
        if (Object.prototype.hasOwnProperty.call(ProjectWeeklyAvailabilityResource, key)) {
            // @ts-ignore
            if (ProjectWeeklyAvailabilityResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectWeeklyAvailabilityResourceFromJSON(json: any): ProjectWeeklyAvailabilityResource {
    return ProjectWeeklyAvailabilityResourceFromJSONTyped(json, false);
}

export function ProjectWeeklyAvailabilityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectWeeklyAvailabilityResource {
    return json as ProjectWeeklyAvailabilityResource;
}

export function ProjectWeeklyAvailabilityResourceToJSON(value?: ProjectWeeklyAvailabilityResource | null): any {
    return value as any;
}

